import React from 'react';

import { CircleWarning } from '@vimeo/iris/icons';

import {
  ColdStorageInfoIcon,
  DownloadButtonColumn,
  FileConfigRow,
  FileDetails,
  FileTitle,
} from '../Styles';
import { FileDownload } from '../types';
import ColdStorageNotification from './ColdStorageNotification';
import DownloadPanelDownloadButton from './DownloadPanelDownloadButton';
import DownloadPanelTooltip from './DownloadPanelTooltip';

type Props = {
  file: FileDownload;
  isDefrosting?: boolean;
  isReview?: boolean;
  coldStorageNotificationToggled?: boolean;
  tooltipShow: boolean;
  tooltipMessage: string;
  tooltipStyle: React.CSSProperties;
  showTooltip: VoidFunction;
  hideTooltip: VoidFunction;
  fetchFile: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  fetchConfirmation: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  coldStorageClose: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const DownloadSourceFileRow = ({
  file,
  isDefrosting = false,
  isReview = false,
  coldStorageNotificationToggled = false,
  tooltipShow = false,
  tooltipMessage = '',
  tooltipStyle = {},
  showTooltip,
  hideTooltip,
  fetchFile,
  fetchConfirmation,
  coldStorageClose,
}: Props) => {
  if (file.error) {
    return (
      <tr className="iris_table-item" key="download_original">
        <td colSpan={3} id="storage-info" className="iris_table-data iris_table-icon">
          <div className="notification notification--warning">
            <div className="notification--warning-icon">
              <CircleWarning className="iris_ic is--16" />
            </div>
            <p className="iris_notification-content">{file.error.message}</p>
          </div>
        </td>
      </tr>
    );
  }

  if (coldStorageNotificationToggled) {
    return (
      <ColdStorageNotification
        key="download_original"
        file={file}
        isDefrosting={isDefrosting}
        fetchConfirmation={fetchConfirmation}
        coldStorageClose={coldStorageClose}
      />
    );
  }

  return (
    <FileConfigRow>
      <FileTitle>
        {file.publicName}
        {file.isCold && (
          <span title={tooltipMessage} onMouseOver={showTooltip} onMouseOut={hideTooltip}>
            <ColdStorageInfoIcon />
          </span>
        )}
        <div>
          {tooltipShow && <DownloadPanelTooltip style={tooltipStyle} message={tooltipMessage} />}
        </div>
      </FileTitle>
      <DownloadButtonColumn>
        <FileDetails>
          {file.width} × {file.height} / {file.size}
        </FileDetails>
        <DownloadPanelDownloadButton file={file} isReview={isReview} fetchFile={fetchFile} />
      </DownloadButtonColumn>
    </FileConfigRow>
  );
};

export default DownloadSourceFileRow;
